export default __webpack_public_path__ + "static/media/chart.166f9ae0.svg";